export enum KeyboardKey {
  ENTER = 'Enter',
  ESCAPE = 'Escape',
  SPACE = ' ',
  ARROW_DOWN = 'ArrowDown',
  ARROW_UP = 'ArrowUp',
  ARROW_LEFT = 'ArrowLeft',
  ARROW_RIGHT = 'ArrowRight',
  HOME = 'Home',
  END = 'End',
  DELETE = 'Delete',
  BACKSPACE = 'Backspace',
  COMMA = ',',
  TAB = 'Tab',
  F2 = 'F2',
}

export enum KeyboardEventType {
  KEYDOWN = 'keydown',
  KEYUP = 'keyup',
  KEYPRESS = 'keypress',
}

export enum WindowEventType {
  FOCUS = 'focus',
  RESIZE = 'resize',
  SCROLL = 'scroll',
  STORAGE = 'storage',
}

export enum MouseEventType {
  CLICK = 'click',
  MOUSEDOWN = 'mousedown',
  MOUSEENTER = 'mouseenter',
  MOUSELEAVE = 'mouseleave',
  MOUSEMOVE = 'mousemove',
  MOUSEUP = 'mouseup',
}

export enum TouchEventType {
  TOUCHSTART = 'touchstart',
  TOUCHMOVE = 'touchmove',
  TOUCHEND = 'touchend',
}
